import React, { FC } from 'react';
import { useIntl, defineMessages } from 'react-intl';

import { trackEvent } from 'dibs-tracking';
import classnames from 'classnames';
import HeartIcon from 'dibs-icons/exports/HeartOutlined';
import styles from './Likes-style.scss';

const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
    label: 'my favorites|my favorites header icon',
};

type Props = {
    onMouseEnter?: () => void;
    favoritesUrl?: string;
    hasUnread?: boolean;
};
const messages = defineMessages({
    label: { id: 'dbl.Header.LikesIcon.label', defaultMessage: 'Favorites' },
});
const LikesIcon: FC<Props> = ({ onMouseEnter, favoritesUrl, hasUnread = false }) => {
    const intl = useIntl();
    return (
        <div className={styles.iconWrapper} onMouseEnter={onMouseEnter}>
            <a
                aria-label={intl.formatMessage(messages.label)}
                data-tn="likes-link"
                href={favoritesUrl}
                className={classnames(styles.icon, {
                    [styles.hasUnread]: hasUnread,
                })}
                onClick={() => {
                    trackEvent(trackingObj);
                }}
            >
                <HeartIcon />
            </a>
        </div>
    );
};

export default LikesIcon;
